import { Blog_ItemConnectionEdge } from 'types/generated/graphql';

export interface BlogEntriesResponse {
  items: BlogItem[];
}

export interface BlogItem extends Blog_ItemConnectionEdge {
  _dateToSort: Date | undefined;
}

export const BlogNewsCategoriesObj = {
  News: '0',
  Medienmitteilungen: '1',
  Architektur: '2',
  Handwerk: '3',
  Tiere: '4',
  Projekte: '5',
  Unterstuetzen: '6',
  Bildung: '7',
  Forschung: '8',
  Sammlung: '9',
};
